import ModalActions from "shared/components/feedback/modals/ModalActions";
import VStack from "shared/components/layout/stack/VStack";
import styled, { createGlobalStyle } from "styled-components";

export const StyledMessageWrapper = styled(VStack)`
    padding: 32px;
    gap: 32px;
`;

export const StyledAction = styled(ModalActions)`
    padding: 16px 32px 32px;
    gap: 8px;
`;

export const StyledRedirectToFooter = createGlobalStyle`
    footer {
        position: absolute;
        bottom: 0;
    }
`;

export const Wrapper = styled.div`
    heigth: 100%;
    width: 480px;
    position: relative;
    padding-top: 38px;
`;
